'use strict';
import React from 'react';
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore";

const CustomLink = (props) => {
    const { disabled, newTab, title, className, hash, children, to, external } = props;
    const target = newTab ? "_blank" : "";

    function onClick(e) { e.preventDefault(); }

    const path = external ? to : prependRoot(to, getApiRoot());
    return disabled ? <Link to="#" onClick={onClick} target={target} title={title} className={className} hash={hash}>{children}</Link> :
        <Link to={path} target={target} title={title} className={className} hash={hash}>{children}</Link>;
};

CustomLink.propTypes = {
    disabled: PropTypes.bool,
    newTab: PropTypes.bool,
    title: PropTypes.string,
    className: PropTypes.string,
    hash: PropTypes.string,
    children: PropTypes.string,
    to: PropTypes.string,
    external: PropTypes.bool
};

export default CustomLink;